import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { InvoiceDetailsComponent } from './invoice-details/components/invoice-details.component';
import { InvoiceHistoryComponent } from './invoice-history/invoice-history.component';


type TabKey = 'details' | 'history';

@Component({
    selector: 'app-invoice',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        InvoiceDetailsComponent,
        InvoiceHistoryComponent,
    ],
    templateUrl: './invoice.component.html',
})
export class InvoiceComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.InvoiceDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.InvoiceHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.InvoiceDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.InvoiceHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
